import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { coreTeamGroups } from "../../data/content.js";

export const clamp01 = (value) => Math.min(1, Math.max(0, value));

export const EASE_IN_OUT = [0.65, 0, 0.35, 1];

// Pill button that reuses the homepage gh-btn and text-roll classes.
export function Btn({ to, href, children, variant = "fill", icon = null, external = false }) {
  const className = `gh-btn gh-btn--${variant}`;
  const inner = (
    <>
      {icon}
      <span className="roll" data-label={children}>
        <span>{children}</span>
      </span>
    </>
  );
  if (to) {
    return (
      <Link className={className} to={to}>
        {inner}
      </Link>
    );
  }
  return (
    <a className={className} href={href} {...(external ? { target: "_blank", rel: "noreferrer" } : {})}>
      {inner}
    </a>
  );
}

// Underlined text link with an arrow, internal or external.
export function ArrowLink({ to, href, children, external = false, className = "" }) {
  const Icon = external ? ArrowUpRight : ArrowRight;
  if (to) {
    return (
      <Link className={`gh-link ${className}`} to={to}>
        {children} <Icon weight="bold" aria-hidden="true" />
      </Link>
    );
  }
  return (
    <a
      className={`gh-link ${className}`}
      href={href}
      {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
    >
      {children} <Icon weight="bold" aria-hidden="true" />
    </a>
  );
}

export function Kicker({ children, className = "" }) {
  return <p className={`ab-kicker ${className}`}>{children}</p>;
}

// Team size, always counted from the data so it never goes stale.
export const TEAM_SIZE = coreTeamGroups.reduce((sum, group) => sum + group.members.length, 0);
